import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const operator = () => {
  const auth = useAuth();

  async function list() {
    let retorno;
    try {
        const {data} = await http.get('/operators', auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function createItem(fornecedor) {
    try {
      const {data} = await http.post('/operators', fornecedor, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      // Ex.: bloqueio por limite do plano (ver EnforcesPlanLimits no
      // backend) — a tela precisa da mensagem real, não só saber que falhou.
      return error?.response?.data?.message ?? 'Não foi possível cadastrar o operador.';
    }
  }

  async function closeCashier(id) {
    try {
      const {data} = await http.post('/operators/'+id+'/close-cashier', null, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function deleteItem(id) {
    try {
      await http.delete('/operators/'+id, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      // Ex.: operador já tem caixa/venda registrada (ver
      // OperatorController::destroy) — a tela precisa mostrar o motivo
      // real, não só saber que falhou.
      return error?.response?.data?.message ?? 'Não foi possível excluir o operador.';
    }
  }

  async function updateItem(fornecedor) {
    try {
      await http.put('/operators/'+fornecedor.id, fornecedor, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return error?.response?.data?.message ?? 'Não foi possível atualizar o operador.';
    }
  }

  return {list, createItem, deleteItem, updateItem,closeCashier}
}
